import { fetchArchivedBookings as fetchArchivedBookingsCall } from 'flux/clients/bookings';

import ActionTypes from './ActionTypes';

export interface Actions {
  fetchArchivedBookings: (options: { page: number; pageSize: number }) => void;
}

export default function actions(
  dispatch: (action: ActionTypes) => void,
): Actions {
  return {
    fetchArchivedBookings: ({ page, pageSize }) => {
      dispatch({ type: 'ARCHIVED_BOOKINGS:FETCHING' });

      fetchArchivedBookingsCall({ page, pageSize })
        .then((result) =>
          dispatch({
            type: 'ARCHIVED_BOOKINGS:FETCHING_SUCCESS',
            payload: { result },
          }),
        )
        .catch((error) =>
          dispatch({
            type: 'ARCHIVED_BOOKINGS:FETCHING_ERROR',
            payload: { error },
          }),
        );
    },
  };
}
